import React, { useEffect, useState } from "react";

// Helper to build track URL
function buildTrackUrl(groupId, licenseId, trackId) {
  return `/u/groups/${groupId}/licenses/${licenseId}/mapped_sequence_progress/${trackId}`;
}

const SequenceTracks = (props) => {
  const { tracks = [], selectedTrackId, groupId, licenseId } = props.navigation;

  // Separate the active track from the rest
  const activeTrack = tracks.find((t) => t.id === selectedTrackId);
  const inactiveTracks = tracks.filter((t) => t.id !== selectedTrackId);

  // State for mobile dropdown toggle
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <div className="sequence-tracks-container">
      {/* --------- DESKTOP: Row of all tracks --------- */}
      <div className="desktop-tracks">
        <div className="mapped-progress-badge-navigation-row">
          {tracks.map((sequenceTrack) => {
            const { id, name, image } = sequenceTrack;
            const isSelected = id === selectedTrackId;

            const buttonClass = isSelected
              ? "btn btn-secondary badge-navigation-link active"
              : "btn btn-secondary badge-navigation-link";

            return (
              <a
                key={id}
                href={buildTrackUrl(groupId, licenseId, id)}
                className={buttonClass}
                // For inactive items, show tooltip on hover (handled in CSS)
                title={name}
              >
                <img
                  className="badge-navigation-icon"
                  src={image.replace(/https:/g, (match, offset) =>
                    offset === 0 ? match : ""
                  )}
                  alt={name}
                  width="100%"
                  height="100%"
                />
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SequenceTracks;
